import { Box, Stack } from "@mui/material";
import type { RiskBucket } from "../types";
import DashboardCard from "./DashboardCard";
import { PendingCardBody } from "./PendingValue";
import RiskDonut, { RiskLegend } from "./RiskDonut";

export default function FleetRiskDonut({ buckets }: { buckets: RiskBucket[] }) {
  const total = buckets.reduce((sum, bucket) => sum + bucket.count, 0);

  return (
    <DashboardCard title="Fleet SPOF Risk Distribution">
      {total === 0 ? (
        <PendingCardBody hint="No confirmed SPOF has been recorded across the fleet yet." />
      ) : (
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, height: "100%" }}
        >
          <RiskDonut buckets={buckets} />
          <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
            <RiskLegend buckets={buckets} />
          </Stack>
        </Box>
      )}
    </DashboardCard>
  );
}
